import { get } from "lodash";
import { useMediaProps } from "@zapier/responsive-utils";

import { Screen } from "@zapier/checkout/esm/constants";
import { Size } from "@zapier/checkout/esm/types";

export const useSize = (): Size => {
  const mediaProps = useMediaProps({
    all: {
      size: "small",
    },
    [Screen.queries.tablet]: {
      size: "medium",
    },
    [Screen.queries.desktop]: {
      size: "large",
    },
  });

  return get(mediaProps, "size");
};
